import React from "react";

import { IProps } from "./accordion-item-header.types";
import "./accordion-item-header.scss";

import ExpandCollapseArrows from "~/expand-collapse-arrows";
import useAccordionItemContext from "~/accordion/use-accordion-item-context";

/**
 * Clickable header for an accordion item. Clicking it should open the item.
 * @param props.children Header content.
 * @returns              Header content and icon to show if the content is open or closed.
 */
const AccordionItemHeader = ({ children }: IProps) => {
    const { canOpen, isOpen, toggleOpen } = useAccordionItemContext();
    return (
        <div className="accordion__accordion-item-header" onClick={toggleOpen}>
            <div className="accordion__accordion-item-header__title">{children}</div>
            {canOpen && <ExpandCollapseArrows isUp={isOpen} />}
        </div>
    );
};

export default AccordionItemHeader;
